const SvgPdfIcon = () => {
  return (
    <svg
      style={{ color: "var(--gray1)" }}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14315_60343)">
        <path
          d="M9.375 3C7.52437 3 6 4.52437 6 6.375V16.5381C5.15241 16.7157 4.5 17.4806 4.5 18.375V26.625C4.5 27.5194 5.15241 28.2843 6 28.4619V29.625C6 31.4756 7.52437 33 9.375 33H26.625C28.4756 33 30 31.4756 30 29.625V28.4619C30.8476 28.2843 31.5 27.5194 31.5 26.625V18.375C31.5 17.4806 30.8476 16.7157 30 16.5381V13.875C29.9999 13.5767 29.8814 13.2905 29.6704 13.0796L29.6587 13.0679L19.9204 3.32959C19.7095 3.11861 19.4233 3.00006 19.125 3H9.375ZM9.375 5.25H18V11.625C18 13.4756 19.5244 15 21.375 15H27.75V16.5H8.25V6.375C8.25 5.74013 8.74013 5.25 9.375 5.25ZM20.25 6.84082L26.1592 12.75H21.375C20.7401 12.75 20.25 12.2599 20.25 11.625V6.84082ZM6.75 18.75H29.25V26.25H6.75V18.75ZM12 19.5C11.586 19.5 11.25 19.836 11.25 20.25V24.75C11.25 25.164 11.586 25.5 12 25.5C12.414 25.5 12.75 25.164 12.75 24.75V24H13.5C14.7405 24 15.75 22.9905 15.75 21.75C15.75 20.5095 14.7405 19.5 13.5 19.5H12ZM17.25 19.5C16.836 19.5 16.5 19.836 16.5 20.25V24.75C16.5 25.164 16.836 25.5 17.25 25.5H18C19.6545 25.5 21 24.1545 21 22.5C21 20.8455 19.6545 19.5 18 19.5H17.25ZM22.5 19.5C22.086 19.5 21.75 19.836 21.75 20.25V24.75C21.75 25.164 22.086 25.5 22.5 25.5C22.914 25.5 23.25 25.164 23.25 24.75V23.25H24.375C24.789 23.25 25.125 22.914 25.125 22.5C25.125 22.086 24.789 21.75 24.375 21.75H23.25V21H24.75C25.164 21 25.5 20.664 25.5 20.25C25.5 19.836 25.164 19.5 24.75 19.5H22.5ZM12.75 21H13.5C13.9132 21 14.25 21.3368 14.25 21.75C14.25 22.1632 13.9132 22.5 13.5 22.5H12.75V21ZM18 21C18.8273 21 19.5 21.6728 19.5 22.5C19.5 23.3272 18.8273 24 18 24V21ZM8.25 28.5H27.75V29.625C27.75 30.2599 27.2599 30.75 26.625 30.75H9.375C8.74013 30.75 8.25 30.2599 8.25 29.625V28.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_14315_60343">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgPdfIcon;
